import { render, staticRenderFns } from "./FilmList.vue?vue&type=template&id=2b5f4cf8&"
import script from "./FilmList.vue?vue&type=script&lang=js&"
export * from "./FilmList.vue?vue&type=script&lang=js&"
import style0 from "./FilmList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilmList.vue"
export default component.exports